import { Controller } from "@hotwired/stimulus"
import { CssHelper } from "~/helpers/css_helper"
import { Chart, registerables } from "chart.js"
import { DateHelper } from "~/helpers/date_helper"

Chart.register(...registerables)

export default class extends Controller {
  static get targets() {
    return ["chartCanvas"]
  }

  static get values() {
    return {
      data: Object,
      labels: Array,
      tooltipLabel: String,
      color: String
    }
  }

  connect() {
    const chartEl = this.chartCanvasTarget.getContext("2d")
    const fontFamily = CssHelper.getVar("--fonts-family-body", document.querySelector(".application-back"))
    const chartData = []
    Object.entries(this.dataValue).forEach(([source, values]) => {
      const color = this.getGraphBarColor(source)

      chartData.push({
        label: source,
        backgroundColor: color,
        data: values
      })
    })

    this.config = {
      type: "bar",
      data: {
        labels: this.labelsValue,
        datasets: chartData
      },
      options: {
        animation: false,
        font: {
          family: fontFamily,
          size: 10,
          color: CssHelper.getVar("--colors-grey-600")
        },
        maintainAspectRatio: false,
        scales: {
          x: {
            stacked: true,
            grid: {
              drawOnChartArea: false,
              drawTicks: false,
              color: CssHelper.getVar("--colors-grey-200")
            },
            ticks: {
              source: "data",
              maxRotation: 0,
              minRotation: 0,
              maxTicksLimit: 6,
              callback: function (val) {
                const date = new Date(this.getLabelForValue(val))
                const currentYear = new Date().getFullYear()
                const showYear = date.getFullYear() !== currentYear
                return DateHelper.fullMonthDate(date, showYear)
              }
            }
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              precision: 0,
              maxTicksLimit: 10
            }
          }
        },
        elements: {
          point: {
            radius: 4,
            borderWidth: 2,
            hoverBorderWidth: 2,
            hoverRadius: 6
          }
        },
        plugins: {
          legend: {
            display: false
          },
          tooltip: {
            mode: "x",
            filter: (tooltipItem) => tooltipItem.raw !== 0,
            usePointStyle: true,
            boxPadding: 8,
            boxWidth: 8,
            yAlign: "center",
            callbacks: {
              title: function (tooltipItems) {
                const date = new Date(tooltipItems[0].label)
                return DateHelper.fullMonthDate(date, true)
              },
              label: function (context) {
                const labelKey = context.dataset.label
                const label = i18n.t(`js.usage.${labelKey}`)
                const value = context.formattedValue

                return `${label}: ${value}`
              }
            },
            padding: 12,
            titleFont: {
              family: fontFamily,
              size: 13
            },
            titleMarginBottom: 4,
            bodyFont: {
              family: fontFamily,
              size: 13
            },
            cornerRadius: 4,
            backgroundColor: "rgba(29, 38, 46, .95)",
            titleColor: CssHelper.getVar("--colors-grey-100"),
            bodyColor: CssHelper.getVar("--colors-grey-100"),
            bodySpacing: 4
          }
        }
      }
    }

    Chart.defaults.borderColor = CssHelper.getVar("--colors-grey-200")
    new Chart(chartEl, this.config)
  }

  getGraphBarColor(source) {
    const colorElement = document.querySelector(`.usage-details-source__colors--${source}`)

    if (colorElement) {
      return CssHelper.getVar("--source-background-color", colorElement)
    } else {
      return CssHelper.getVar(this.colorValue)
    }
  }
}
